module.exports = __webpack_public_path__ + "static/media/screen5.fb1693c6.png";